import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { LayoutDashboard, GitCommitVertical, Images, FileText, Wallet, MessageSquare } from "lucide-react";
import { pp } from "@/lib/portalHost";

const STEPS = [
  [LayoutDashboard, "Tableau de bord", "L'essentiel de votre projet en un coup d'œil : avancement, montants, prochaine étape et dernières actualités.", ""],
  [GitCommitVertical, "Avancement", "Suivez chaque phase de votre chantier et les dates prévues, mises à jour par nos équipes.", "/avancement"],
  [Images, "Photos & documents", "Retrouvez les photos du chantier, vos plans et tous les documents partagés par OMNIBAT.", "/photos"],
  [FileText, "Devis & contrats", "Consultez vos devis et acceptez-les ou refusez-les en ligne avec votre signature électronique.", "/devis"],
  [Wallet, "Factures & paiements", "Téléchargez vos factures et suivez vos paiements ainsi que le solde restant.", "/paiements"],
  [MessageSquare, "Messages", "Une question ? Écrivez directement à l'équipe OMNIBAT, nous vous répondons ici.", "/messages"],
];

export default function PortalTour({ onDone }) {
  const [i, setI] = useState(0);
  const nav = useNavigate();
  const [Icon, title, text, to] = STEPS[i];
  const last = i === STEPS.length - 1;
  const go = () => { nav(pp(to)); onDone(); };
  return (
    <Dialog open onOpenChange={(o) => !o && onDone()}>
      <DialogContent className="w-[calc(100vw-24px)] max-w-sm rounded-2xl" data-testid="portal-tour-dialog">
        <p className="text-xs text-slate-400" data-testid="portal-tour-step">Étape {i + 1} sur {STEPS.length}</p>
        <div key={i} className="animate-in fade-in slide-in-from-right-4 duration-300">
          <div className="h-14 w-14 rounded-2xl bg-emerald-50 text-[#076633] flex items-center justify-center mb-4"><Icon className="h-7 w-7" /></div>
          <DialogHeader><DialogTitle className="font-head text-xl text-left" data-testid="portal-tour-title">{title}</DialogTitle></DialogHeader>
          <p className="text-sm text-slate-600 mt-2 min-h-[60px]">{text}</p>
          {to && <button onClick={go} className="text-sm text-[#076633] underline underline-offset-2 mt-1" data-testid="portal-tour-goto">Ouvrir cette rubrique</button>}
        </div>
        <div className="flex justify-center gap-1.5 my-2">{STEPS.map((_, k) => <span key={k} className={`h-1.5 rounded-full transition-all ${k === i ? "w-6 bg-[#076633]" : "w-1.5 bg-slate-200"}`} />)}</div>
        <div className="flex gap-2">
          {i > 0 ? <Button variant="outline" onClick={() => setI(i - 1)} className="flex-1 rounded-xl" data-testid="portal-tour-prev">Précédent</Button>
            : <Button variant="ghost" onClick={onDone} className="flex-1 rounded-xl text-slate-500" data-testid="portal-tour-skip">Passer</Button>}
          <Button onClick={() => (last ? onDone() : setI(i + 1))} className="flex-1 rounded-xl bg-[#076633] hover:bg-[#065a2c] text-white" data-testid="portal-tour-next">{last ? "C'est parti" : "Suivant"}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
